<template>
  <div>
    <div class="page-header">
      <parallax
        class="page-header-image"
        style="background-image: url('img/transplus_landing.jpg')"
      />
      
      <!--
      <video autoplay muted loop id="myVideo">
        <source src="img/TorontoTimelapse.mp4" type="video/mp4" />
      </video>      
      -->

      <div class="content-center">
        <div class="container">
          <h1
            class="title"
            v-html="$t('index.header')"
          >
            Stay on course with our <br> Supply Chain Resources
          </h1>
          <!--
          <div class="text-center">
            <a href="#pablo" class="btn btn-primary btn-icon btn-round">
              <i class="fab fa-facebook-square"></i>
            </a>
            <a href="#pablo" class="btn btn-primary btn-icon btn-round">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="#pablo" class="btn btn-primary btn-icon btn-round">
              <i class="fab fa-google-plus"></i>
            </a>
          </div>
          -->
        </div>
      </div>
    </div>

    <!--- TOP -->
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2
              class="title"
              v-html="$t('index.over', { year: bday })"
            >
              Over <span class="tpgreen">{{ bday }} years</span> of logistics <span class="tpgreen">experience.</span>
            </h2>
                                 
            <h5
              class="description"
              v-html="$t('index.ourpeople')"
            >
              Our people, our network, and our facilities are your resources. Stay focused on your core business and let us provide you with the support you deserve.                
            </h5>
            <br><br>
            <a
              class="nav-link requestaquote"
              href="/quote"
              style="color:white; text-transform: capitalize;"
            >{{ $t("navbar.quote") }}</a>
          </div>
        </div>
      </div>
    </div>
    

    <!-- Services -->
    <div style="min-height:550px">
      <div class="container">
        <div
          class="row elgrey"
          style="padding-top:25px"
        >
          <div
            class="col-md-4 pophover elmaster"
            @click="$router.push('warehouse')"
          >
            <card style="min-height:520px">
              <img
                slot="image"
                class="card-img-top"
                :src="imgWare"
                alt="Card image cap"
              >              
              <h4
                class="card-title"
                v-html="$t('General.WarehouseDistribution')"
              >
                Warehousing and Distribution
              </h4>
              <p
                class="card-text"
                style="font-size:14px"
                v-html="$t('index.Warehousedesc')"
              >
                From a simple and cost-effective warehousing solution to a long-term inventory management system, we commit to providing you a customized approach.
              </p>             
            </card>
          </div>

          <div
            class="col-md-4 pophover elmaster"
            @click="$router.push('transportation')"
          >
            <card style="min-height:520px">
              <img
                slot="image"
                class="card-img-top"
                :src="imgTrans"
                alt="Card image cap"
              >              
              <h4
                class="card-title"
                v-html="$t('General.Transportation')"
              >
                Transportation
              </h4>
              <p
                class="card-text"
                style="font-size:14px"
                v-html="$t('index.Transpdesc')"
              >
                Whether you need to move a single pallet across town or an entire truckload across the country, our reliable asset-based division offers flexible transport services.
              </p>              
            </card>
          </div>

          <div
            class="col-md-4 pophover elmaster"
            @click="$router.push('freightbrokerage')"
          >
            <card style="min-height:520px">
              <img
                slot="image"
                class="card-img-top"
                :src="imgFreight"
                alt="Card image cap"
              >            
              <h4
                class="card-title"
                v-html="$t('General.FreightBrokerage')"
              >
                Freight Brokerage
              </h4>
              <p
                class="card-text"
                style="font-size:14px"
                v-html="$t('index.freightdesc')"
              >
                Over the years, we have built strong partnerships throughout the supply chain, enabling us to efficiently manage your product distribution. By assessing your needs, we provide custom solutions at competitive rates.
              </p>              
            </card>
          </div>
        </div>
      </div>
    </div>    
  
    <!-- new layout : JC -->
    <!--
    <div class="section">
      <div class="grid" >
        <div class="gItem" style="background-image: url('img/food.jpg');background-size:cover;"><div style="background-color:rgba(0,0,0,0.5);color:white;" v-html="$t('General.FoodBeverage')">Food and Beverage</div></div>
        <div class="gItem" style="background-image: url('img/consumer.jpg');background-size:cover"><div style="background-color:rgba(0,0,0,0.5); color:white; padding:4px" v-html="$t('General.ConsumerGoods')">Consumer Goods</div></div>
        <div class="gItem" style="background-image: url('img/ecom.jpg');background-size:cover"><div style="background-color:rgba(0,0,0,0.5); color:white; padding:4px" v-html="$t('General.eCommerce')">E-commerce</div></div>
        <div class="gItem" style="background-image: url('img/manufacture.jpg');background-size:cover"><div style="background-color:rgba(0,0,0,0.5);color:white; padding:4px" v-html="$t('General.Manufacturing')">Manufacturing</div></div>        
        <div class="gItem" style="background-image: url('img/medical.jpg');background-size:cover"><div style="background-color:rgba(0,0,0,0.5); color:white; padding:4px" v-html="$t('General.Health')">Medical Supplies</div></div>
        <div class="gItem" style="background-image: url('img/pharma.jpg');background-size:cover"><div style="background-color:rgba(0,0,0,0.5); color:white; padding:4px" v-html="$t('General.Health')">Pharmaceutical</div></div>
        <div class="gItem" style="background-image: url('img/retail.jpg');background-size:cover"><div style="background-color:rgba(0,0,0,0.5); color:white; padding:4px" v-html="$t('General.RetailDis')">Retail Distribution</div></div>
      </div>
    </div>
    -->
    <!-- end new layout -->

    <!-- We service a wide range of industries. -->
    <div class="section">
      <div
        class="container"
        style="max-width: 800px"
      >
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto  text-center">
            <h2
              class="title"
              v-html="$t('index.industry')"
            >
              We provide services to a wide range of <span class="tpgreen">industries.</span class="tpgreen"></span>
            </h2>
            <h5 class="description">
              These include:                
            </h5>
          </div>
        </div>

        <div class="row">
          <div
            v-for="{ imgSrc, text, fallback } in [
              {
                imgSrc: 'img/food.jpg',
                text: $t('General.FoodBeverage'),
                fallback: 'Food and Beverage',
              },
              {
                imgSrc: 'img/consumer.jpg',
                text: $t('General.ConsumerGoods'),
                fallback: 'Consumer Goods',
              },
              {
                imgSrc: 'img/ecom.jpg',
                text: $t('General.eCommerce'),
                fallback: 'eCommerce',
              },
              {
                imgSrc: 'img/manufacture.jpg',
                text: $t('General.Manufacturing'),
                fallback: 'Manufacturing',
              },              
              {
                imgSrc: 'img/medical2.jpg',
                text: $t('General.Health'),
                fallback: 'Healthcare',
              },
              {
                imgSrc: 'img/retail.jpg',
                text: $t('General.RetailDis'),
                fallback: 'Retail Distribution',
              },
              
            ]"
            :key="imgSrc"
            class="col-6 col-sm-4"
          >
            <div class="features-text">
              <div
                style="text-align: center"
                v-html="text"
              >
                {{ fallback }}
              </div>
            </div>

            <div style="padding-top: 100%; position: relative;">
              <div
                style="position: absolute; top: 0; right: 0; bottom: 0; left: 0; background-size: cover; background-position: center; filter: grayscale(50%);"
                :style="{ 'background-image': `url(${imgSrc})` }"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- -->

    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2
              class="title"
              v-html="$t('index.fullspectrum')"
            >
              <span class="tpgreen">Full </span>Spectrum Services.</span>
            </h2>
            <h5
              class="description"
              v-html="$t('index.fullspectrumDesc')"
            >
              Utilize our solution based approach, and let us seamlessly service your consumer goods to major retailers in North America.
            </h5>
          </div>
        </div>
      </div>
    </div> 

    <!--<div class="section gotoservices" >-->
    <div class="col-md-8 ml-auto mr-auto text-center">
      <!-- <a href="/quote" v-html="$t('General.getquotebusiness')">Get a quote for your business<span class="tpgreen">→</span></a> -->
      <a
        class="nav-link requestaquote"
        href="/quote"
        style="color:white; text-transform: capitalize;"
      >{{ $t("navbar.quote") }}</a>
    </div>
  </div>
</template>

<script scoped>
import {  NavLink, Card } from '@/components';
import { Button, FormGroupInput } from '@/components';
export default {
  metaInfo: {
    title: 'Transplus - Warehousing and Third Party Logistics (3PL)',
    /*titleTemplate: '%s - Landing Page',*/
    htmlAttrs: {
      lang: 'en',
      amp: true
    },
    meta: [
      {content: 'text/html; charset=utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {name: 'description', content: 'Montreal Toronto warehouse storage and third party logistics 3PL. Order fulfillment, pick and pack, cross docking, labelling, kitting, assembly, import export. High security'},
      {name: 'keywords', content: 'Warehouse, Warehousing,  Transport, Transportation, Pick and Pack, Packaging, Fulfillment, Kitting, Labelling, Labeling, Assembly, Montreal, Toronto, Missisuaga, Pointe Claire, Ville St-Laurent'}
    ]    
  },    
  name: 'Landing',
  bodyClass: 'landing-page',
  components: {
    Card,
    NavLink,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {
      bday: new Date().getFullYear() - 1993, 
      imgWare: "img/transplus_whse3.jpg",
      imgTrans: "img/transplus_transport.jpg",
      imgFreight: "img/transplus_fb.jpg",       
    };
  },
  mounted (){
    var vid = document.getElementById("myVideo");
    // vid.volume = 0.2;
  }
};
</script>
<style scoped>
.lnk {
  color:white;  
}
.lnk:hover{
  color:white;
  text-decoration: none;
}
/*-- --*/
.imgservices{
  filter: grayscale(50%);
  width:200; 
  height:200px;
}
.imgautoheight{
  background-size: auto 200px;
}
.imgboxshadow{
  box-shadow: 1px 3px 14px 2px rgba(0,0,0,0.15);
}
/*-- */

#myVideo {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  opacity:1;  
}
.border{
  border-style: none;
}
.border:hover{
  border-style: dotted;
}

/* ------------------- */
.grid {
  display: grid;
  grid-template-columns: repeat(4,300px);
  grid-template-rows: repeat(4,300px);
  grid-gap: 5px;
  justify-content: center; /* space-around : start : end : left : right : baseline */

}
.gItem {
  /* center everything */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items:center;
  /* ---------------- */
  
}

@media only screen  and (min-width:768px) and (max-width:1280px) {  
  .card-title{
    /*background-color: #eee;*/
    height: 50px;
  }
}

.features-text {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem 0;
  font-size: 16px;
  min-height: 48px;
}

@media screen and (min-width: 322px) {
  .features-text {
    min-height: auto;
  }
}

@media screen and (min-width: 606px) {
  .features-text {
    font-size: 21px;
  }
}


@media only screen and (max-width: 600px) { 
  .page-header-small{
            min-height: 40vh;
            max-height: 440px;
    }
  .title{
    font-size:2.75em;
  }
}
</style>
